/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_calculator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/calculator */ "./src/js/modules/calculator.js");
/* harmony import */ var _modules_redirection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/redirection */ "./src/js/modules/redirection.js");
/* harmony import */ var _modules_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/currency */ "./src/js/modules/currency.js");
/* harmony import */ var _modules_footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/footer */ "./src/js/modules/footer.js");
/* harmony import */ var _modules_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/modal */ "./src/js/modules/modal.js");
/* harmony import */ var _modules_servicing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/servicing */ "./src/js/modules/servicing.js");
/* harmony import */ var _modules_slides__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/slides */ "./src/js/modules/slides.js");
/* harmony import */ var _modules_splititInit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/splititInit */ "./src/js/modules/splititInit.js");








window.calculator = _modules_calculator__WEBPACK_IMPORTED_MODULE_0__.default;
window.slides = _modules_slides__WEBPACK_IMPORTED_MODULE_6__.default;
window.servicing = _modules_servicing__WEBPACK_IMPORTED_MODULE_5__.default;
window.modal = _modules_modal__WEBPACK_IMPORTED_MODULE_4__.default;
(0,_modules_splititInit__WEBPACK_IMPORTED_MODULE_7__.default)();
(0,_modules_footer__WEBPACK_IMPORTED_MODULE_3__.default)();
(0,_modules_redirection__WEBPACK_IMPORTED_MODULE_1__.default)();
(0,_modules_currency__WEBPACK_IMPORTED_MODULE_2__.default)();
$(document).ready(function () {
  _modules_slides__WEBPACK_IMPORTED_MODULE_6__.default.featureGallery.init();
  _modules_slides__WEBPACK_IMPORTED_MODULE_6__.default.sliderGallery.init();
});

/***/ }),

/***/ "./src/js/modules/calculator.js":
/*!**************************************!*\
  !*** ./src/js/modules/calculator.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  price: 0,
  modal: function modal(price) {
    this.price = price;
    $('#splitit-value').val(this.getPrice());
    this.updateCalculator();
    $.magnificPopup.open({
      items: {
        src: '#splitit-product-modal'
      },
      type: 'inline',
      removalDelay: 300,
      mainClass: 'mfp-zoom-in'
    });
  },
  getPrice: function getPrice() {
    var variantId = ShopifyAnalytics && ShopifyAnalytics.meta.selectedVariantId;
    var productVariants = this.getVariants();
    var productVariant = productVariants.find(function (variant) {
      return variant.id == variantId;
    });
    return productVariant ? productVariant.price / 100 : this.price / 100;
  },
  getVariants: function getVariants() {
    return ShopifyAnalytics && ShopifyAnalytics.meta.product.variants;
  },
  updateCalculator: function updateCalculator() {
    $('#splitit-total').text(this.getInstalment());
    $('#splitit-payment-plan-total').text(this.floatToString(this.getValue()));
    $('#splitit-payment-plan-term').text(this.getTerm());
    $('.splitit-payment-plan-increment').text(this.getInstalment());
    $('#splitit-one').text(this.calcHold(1));
    $('#splitit-two').text(this.calcHold(2));
  },
  getInstalment: function getInstalment() {
    var value = this.getValue();
    var term = this.getTerm();
    return this.floatToString(value / term);
  },
  getValue: function getValue() {
    return parseFloat($("#splitit-value").val());
  },
  getTerm: function getTerm() {
    return parseInt($("#splitit-term").val());
  },
  calcHold: function calcHold(payment) {
    var value = this.getValue();
    var term = this.getTerm();
    var price = value / term;
    return this.floatToString(value - price * payment);
  },
  floatToString: function floatToString(value) {
    return isNaN(value) ? '' : value.toFixed(2).toString();
  }
});

/***/ }),

/***/ "./src/js/modules/currency.js":
/*!************************************!*\
  !*** ./src/js/modules/currency.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ currency)
/* harmony export */ });
function currency() {
  $(document).ready(function () {
    $('#currency-select-mobile').click(function () {
      $('.locale-select-mobile .currency-select-options').toggleClass('active');
    });
  });
}

/***/ }),

/***/ "./src/js/modules/footer.js":
/*!**********************************!*\
  !*** ./src/js/modules/footer.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ footer)
/* harmony export */ });
function footer() {
  $(document).ready(function () {
    var stickySubmit = $("#sticky-footer-submit");
    var stickySelect = $("#sticky-footer-select");
    var ebikeSelector = $("#ebike-spec-select");

    if (ebikeSelector.length) {
      ebikeSelector.change(function () {
        return location.assign(ebikeSelector.val());
      });
    }

    if (stickySubmit.length) {
      stickySubmit.click(function () {
        $("#AddToCart-product-template").trigger("click");
      });
    }

    if (stickySelect.length) {
      var updateMessage = function updateMessage() {
        var messages = {
          spec: {
            "williams-racing-launch-edition-ebike": {
              Splitit: '.payment-message--splitit',
              Full: ".payment-message--full",
              Deposit: ".payment-message--deposit"
            },
            "williams-racing-carbon-drive-edition-ebike": {
              Splitit: '.payment-message--splitit',
              Full: ".payment-message--full",
              Deposit: ".payment-message--deposit"
            },
            "williams-racing-escooter": {
              Splitit: '.payment-message--splitit',
              Full: ".payment-message--full",
              Deposit: ".payment-message--deposit"
            }
          }
        };
        var option = stickySelect[0][stickySelect[0].selectedIndex].getAttribute("id"),
            value = option == "splitit-footer" ? "Splitit" : stickySelect.val();

        if (value !== "Deposit") {
          $("#splitit-container").show();
          $("#full-price-text").hide();
          $(".label--deposit").hide();
        } else {
          $("#splitit-container").hide();
          $(".label--deposit").show();
          $("#full-price-text").show();
        }

        if (messages.spec[specSelectVal]) {
          $("span", "#payment-message").hide();
          $("span", "#payment-message-mobile").hide();
          $(messages.spec[specSelectVal][value], "#payment-message").show();
          $(messages.spec[specSelectVal][value], "#payment-message-mobile").show();
        }
      };

      var specSelect = $('#specification-select-wrapper > select');
      var specSelectVal = specSelect.val() ? specSelect.val() : document.body.id;
      updateMessage();
      stickySelect.change(function () {
        var input = $("#purchase-select-wrapper > label").attr("for");
        $("#" + input).val($(this).val()).trigger("change");
        updateMessage();
      });
      specSelect.change(function () {
        updateMessage();
      });
      Weglot.on("languageChanged", function (newLang, prevLang) {
        updateMessage();
      });
    }
  });
}

/***/ }),

/***/ "./src/js/modules/modal.js":
/*!*********************************!*\
  !*** ./src/js/modules/modal.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ modal)
/* harmony export */ });
function modal(id) {
  $.magnificPopup.open({
    items: {
      src: "#".concat(id)
    },
    type: 'inline',
    removalDelay: 300,
    mainClass: 'mfp-zoom-in'
  });
}

/***/ }),

/***/ "./src/js/modules/redirection.js":
/*!***************************************!*\
  !*** ./src/js/modules/redirection.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ redirection)
/* harmony export */ });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function redirection() {
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  function setLocale() {
    $.magnificPopup.close();
    $.cookie('localeSet', true, {
      expires: 30,
      path: '/'
    });
  }

  ;
  $(document).ready(function () {
    if ($(".currency-select").length) {
      var currencies = {
        'EUR': 'EUR',
        'AUD': 'AUD',
        'CAD': 'CAD',
        'CHF': 'CHF',
        'CNY': 'CNY',
        'HKD': 'HKD',
        'JPY': 'JPY',
        'KRW': 'KRW',
        'NZD': 'NZD',
        'SEK': 'SEK',
        'SGD': 'SGD',
        'USD': 'USD'
      },
          current = $('.current-select-options'),
          options = $('.currency-select-options');
      var content = '';

      for (var _i = 0, _Object$entries = Object.entries(currencies); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        content += "<p class=\"currency-option\" data-value=\"".concat(key, "\"><a href=\"#\">").concat(value, "</a></p>");
      }

      options.each(function () {
        $(this).html(content);
      });
      $('.currency-option').on('click', function (e) {
        e.preventDefault();
        var currency = $(this).data('value');
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/update", true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            location.reload();
          }
        };

        xhr.send(JSON.stringify({
          'form_type': 'currency',
          'return_to': '/',
          'currency': currency
        }));
      });
    }

    if ($("#currency_form").length) {
      document.querySelector("#currency_form").addEventListener("change", currencyFormSubmit);
    }

    $.get("https://ipinfo.io", function (response) {
      var _currencies;

      var country = response.country,
          countries = {
        BD: "Bangladesh",
        BE: "Belgium",
        BF: "Burkina Faso",
        BG: "Bulgaria",
        BA: "Bosnia and Herzegovina",
        BB: "Barbados",
        WF: "Wallis and Futuna",
        BL: "Saint Barthelemy",
        BM: "Bermuda",
        BN: "Brunei",
        BO: "Bolivia",
        BH: "Bahrain",
        BI: "Burundi",
        BJ: "Benin",
        BT: "Bhutan",
        JM: "Jamaica",
        BV: "Bouvet Island",
        BW: "Botswana",
        WS: "Samoa",
        BQ: "Bonaire, Saint Eustatius and Saba ",
        BR: "Brazil",
        BS: "Bahamas",
        JE: "Jersey",
        BY: "Belarus",
        BZ: "Belize",
        RU: "Russia",
        RW: "Rwanda",
        RS: "Serbia",
        TL: "East Timor",
        RE: "Reunion",
        TM: "Turkmenistan",
        TJ: "Tajikistan",
        RO: "Romania",
        TK: "Tokelau",
        GW: "Guinea-Bissau",
        GU: "Guam",
        GT: "Guatemala",
        GS: "South Georgia and the South Sandwich Islands",
        GR: "Greece",
        GQ: "Equatorial Guinea",
        GP: "Guadeloupe",
        JP: "Japan",
        GY: "Guyana",
        GG: "Guernsey",
        GF: "French Guiana",
        GE: "Georgia",
        GD: "Grenada",
        GB: "United Kingdom",
        GA: "Gabon",
        SV: "El Salvador",
        GN: "Guinea",
        GM: "Gambia",
        GL: "Greenland",
        GI: "Gibraltar",
        GH: "Ghana",
        OM: "Oman",
        TN: "Tunisia",
        JO: "Jordan",
        HR: "Croatia",
        HT: "Haiti",
        HU: "Hungary",
        HK: "Hong Kong",
        HN: "Honduras",
        HM: "Heard Island and McDonald Islands",
        VE: "Venezuela",
        PR: "Puerto Rico",
        PS: "Palestinian Territory",
        PW: "Palau",
        PT: "Portugal",
        SJ: "Svalbard and Jan Mayen",
        PY: "Paraguay",
        IQ: "Iraq",
        PA: "Panama",
        PF: "French Polynesia",
        PG: "Papua New Guinea",
        PE: "Peru",
        PK: "Pakistan",
        PH: "Philippines",
        PN: "Pitcairn",
        PL: "Poland",
        PM: "Saint Pierre and Miquelon",
        ZM: "Zambia",
        EH: "Western Sahara",
        EE: "Estonia",
        EG: "Egypt",
        ZA: "South Africa",
        EC: "Ecuador",
        IT: "Italy",
        VN: "Vietnam",
        SB: "Solomon Islands",
        ET: "Ethiopia",
        SO: "Somalia",
        ZW: "Zimbabwe",
        SA: "Saudi Arabia",
        ES: "Spain",
        ER: "Eritrea",
        ME: "Montenegro",
        MD: "Moldova",
        MG: "Madagascar",
        MF: "Saint Martin",
        MA: "Morocco",
        MC: "Monaco",
        UZ: "Uzbekistan",
        MM: "Myanmar",
        ML: "Mali",
        MO: "Macao",
        MN: "Mongolia",
        MH: "Marshall Islands",
        MK: "Macedonia",
        MU: "Mauritius",
        MT: "Malta",
        MW: "Malawi",
        MV: "Maldives",
        MQ: "Martinique",
        MP: "Northern Mariana Islands",
        MS: "Montserrat",
        MR: "Mauritania",
        IM: "Isle of Man",
        UG: "Uganda",
        TZ: "Tanzania",
        MY: "Malaysia",
        MX: "Mexico",
        IL: "Israel",
        FR: "France",
        IO: "British Indian Ocean Territory",
        SH: "Saint Helena",
        FI: "Finland",
        FJ: "Fiji",
        FK: "Falkland Islands",
        FM: "Micronesia",
        FO: "Faroe Islands",
        NI: "Nicaragua",
        NL: "Netherlands",
        NO: "Norway",
        NA: "Namibia",
        VU: "Vanuatu",
        NC: "New Caledonia",
        NE: "Niger",
        NF: "Norfolk Island",
        NG: "Nigeria",
        NZ: "New Zealand",
        NP: "Nepal",
        NR: "Nauru",
        NU: "Niue",
        CK: "Cook Islands",
        XK: "Kosovo",
        CI: "Ivory Coast",
        CH: "Switzerland",
        CO: "Colombia",
        CN: "China",
        CM: "Cameroon",
        CL: "Chile",
        CC: "Cocos Islands",
        CA: "Canada",
        CG: "Republic of the Congo",
        CF: "Central African Republic",
        CD: "Democratic Republic of the Congo",
        CZ: "Czech Republic",
        CY: "Cyprus",
        CX: "Christmas Island",
        CR: "Costa Rica",
        CW: "Curacao",
        CV: "Cape Verde",
        CU: "Cuba",
        SZ: "Swaziland",
        SY: "Syria",
        SX: "Sint Maarten",
        KG: "Kyrgyzstan",
        KE: "Kenya",
        SS: "South Sudan",
        SR: "Suriname",
        KI: "Kiribati",
        KH: "Cambodia",
        KN: "Saint Kitts and Nevis",
        KM: "Comoros",
        ST: "Sao Tome and Principe",
        SK: "Slovakia",
        KR: "South Korea",
        SI: "Slovenia",
        KP: "North Korea",
        KW: "Kuwait",
        SN: "Senegal",
        SM: "San Marino",
        SL: "Sierra Leone",
        SC: "Seychelles",
        KZ: "Kazakhstan",
        KY: "Cayman Islands",
        SG: "Singapore",
        SE: "Sweden",
        SD: "Sudan",
        DO: "Dominican Republic",
        DM: "Dominica",
        DJ: "Djibouti",
        DK: "Denmark",
        VG: "British Virgin Islands",
        DE: "Germany",
        YE: "Yemen",
        DZ: "Algeria",
        US: "United States",
        UY: "Uruguay",
        YT: "Mayotte",
        UM: "United States Minor Outlying Islands",
        LB: "Lebanon",
        LC: "Saint Lucia",
        LA: "Laos",
        TV: "Tuvalu",
        TW: "Taiwan",
        TT: "Trinidad and Tobago",
        TR: "Turkey",
        LK: "Sri Lanka",
        LI: "Liechtenstein",
        LV: "Latvia",
        TO: "Tonga",
        LT: "Lithuania",
        LU: "Luxembourg",
        LR: "Liberia",
        LS: "Lesotho",
        TH: "Thailand",
        TF: "French Southern Territories",
        TG: "Togo",
        TD: "Chad",
        TC: "Turks and Caicos Islands",
        LY: "Libya",
        VA: "Vatican",
        VC: "Saint Vincent and the Grenadines",
        AE: "United Arab Emirates",
        AD: "Andorra",
        AG: "Antigua and Barbuda",
        AF: "Afghanistan",
        AI: "Anguilla",
        VI: "U.S. Virgin Islands",
        IS: "Iceland",
        IR: "Iran",
        AM: "Armenia",
        AL: "Albania",
        AO: "Angola",
        AQ: "Antarctica",
        AS: "American Samoa",
        AR: "Argentina",
        AU: "Australia",
        AT: "Austria",
        AW: "Aruba",
        IN: "India",
        AX: "Aland Islands",
        AZ: "Azerbaijan",
        IE: "Ireland",
        ID: "Indonesia",
        UA: "Ukraine",
        QA: "Qatar",
        MZ: "Mozambique"
      },
          currency = $('form#currency_form select').val(),
          currencies = (_currencies = {
        //EUR
        'AT': 'EUR',
        'BE': 'EUR',
        'BG': 'EUR',
        'HR': 'EUR',
        'CY': 'EUR',
        'CZ': 'EUR',
        'DK': 'EUR',
        'EE': 'EUR',
        'FI': 'EUR',
        'FR': 'EUR',
        'DE': 'EUR',
        'GR': 'EUR',
        'HU': 'EUR',
        'IE': 'EUR',
        'IT': 'EUR',
        'LV': 'EUR',
        'LT': 'EUR',
        'LU': 'EUR',
        'MT': 'EUR',
        'NL': 'EUR',
        'PL': 'EUR',
        'PT': 'EUR',
        'RO': 'EUR',
        'SK': 'EUR',
        'SI': 'EUR',
        'ES': 'EUR',
        'SE': 'EUR',
        'LI': 'EUR',
        'CH': 'EUR',
        'AD': 'EUR',
        'GP': 'EUR',
        'MQ': 'EUR',
        'YT': 'EUR',
        'MC': 'EUR',
        'GF': 'EUR',
        'RE': 'EUR',
        'PM': 'EUR',
        'SM': 'EUR',
        'VA': 'EUR',
        'AQ': 'EUR',
        'ME': 'EUR',
        'BL': 'EUR',
        'XK': 'EUR',
        'AX': 'EUR',
        'MF': 'EUR',
        // AUD
        'AU': 'AUD',
        // UK
        'GB': 'GBP',
        //US
        'US': 'USD',
        // JPY
        'JP': 'JPY',
        // CAD
        'CA': 'CAD'
      }, _defineProperty(_currencies, "CH", 'CHF'), _defineProperty(_currencies, "LI", 'CHF'), _defineProperty(_currencies, 'CN', 'CNY'), _defineProperty(_currencies, "SE", 'SEK'), _defineProperty(_currencies, 'HK', 'HKD'), _defineProperty(_currencies, 'KR', 'KRW'), _defineProperty(_currencies, 'NZ', 'NZD'), _defineProperty(_currencies, 'SG', 'SGD'), _currencies);

      if (country in currencies && currency !== currencies[country]) {
        $('#currency-select-location').text(countries[country]);
        $('#geoloc-currency-select-code').text(currencies[country]);
        $('#geoloc-currency-select').on('click', function () {
          window.location.href = "".concat(window.location.href, "?currency=").concat(currencies[country]);
        });

        if (!$.cookie('localeSet')) {
          $.magnificPopup.open({
            items: {
              src: '#currency-select-modal'
            },
            type: 'inline',
            removalDelay: 300,
            mainClass: 'mfp-zoom-in redirection-modal',
            alignTop: screen.width < 1025,
            closeMarkup: "<button title=\"%title%\" type=\"button\" class=\"mfp-close\" onclick=\"setLocale()\">\xD7</button>"
          });
        }
      }
    }, 'json');
  });
}

/***/ }),

/***/ "./src/js/modules/servicing.js":
/*!*************************************!*\
  !*** ./src/js/modules/servicing.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ servicing)
/* harmony export */ });
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var map = document.getElementById("servicing-map"),
    servicingMap,
    markers;
function servicing() {
  if (map) {
    $.get("https://ipinfo.io/json", function (response) {
      var countryISO = response.country;
      fetch("https://restcountries.com/v3.1/alpha/".concat(countryISO, "?fields=name")).then(function (response) {
        return response.json();
      }).then(function (response) {
        var countryName = response.name.common;
        var bounds = new google.maps.LatLngBounds();
        servicingMap = new google.maps.Map(map, {});
        var data = "//motionracing.com/cdn/shop/t/2/assets/servicing.json?v=59715874739805451011627498101";
        $.getJSON(data, function (json) {
          markers = json.map(function (location, index) {
            var latLng = new google.maps.LatLng(location.lat, location.lng);
            var marker = new google.maps.Marker({
              position: latLng,
              icon: "//motionracing.com/cdn/shop/t/2/assets/map-marker-service.svg?v=51685224856494795841633496390"
            });
            location.id = index;
            bounds.extend(latLng);
            var content = "<div class=\"marker-info\"><p class=\"tag\">Service center</p><h4>".concat(location.dealer, "</h4><p>").concat(location.location, "</p></div>");
            var infowindow = new google.maps.InfoWindow({
              content: content
            });
            marker.addListener("click", function () {
              servicingMap.setZoom(16);
              servicingMap.setCenter(marker.getPosition());
              infowindow.open(servicingMap, marker);
            });
            return marker;
          });
          var clusterOptions = {
            styles: [{
              url: "//motionracing.com/cdn/shop/t/2/assets/cluster-dot.svg?v=111632137611287391291626245178",
              width: 32,
              height: 32,
              fontFamily: "'Inter', sans-serif",
              textSize: 18,
              textColor: "white",
              anchorText: [5, 0]
            }]
          };
          new MarkerClusterer(servicingMap, markers, clusterOptions);
          fillServicingTable(json, "country", countryName);
          checkForExistingRetailersInCountry(servicingMap, countryName);
          countrySelectDropdown(json, 'country', countryName);
          $("#servicing-sort").change(function () {
            fillServicingTable(json, $(this).val(), countryName);
          });
          $("select, #servicing-list").change(function (e) {
            countryName = $(this).val();

            if ($(this).val()) {
              $("[data-country=\"".concat(countryName, "\"]"), "#servicing-list").attr('selected', 'selected');
              checkForExistingRetailersInCountry(servicingMap, countryName);
            }
          });
        });
      })["catch"](function (error) {
        console.log(error);
      });
    });
  }
}

function checkForExistingRetailersInCountry(servicingMap, countryName) {
  $("[data-country]", "#servicing-table").hide();
  $("[data-country=\"".concat(countryName, "\"]"), "#servicing-table").show();

  if ($("[data-country=\"".concat(countryName, "\"]:visible"), "#servicing-table").length) {
    centerMapToCountry(countryName);
  } else {
    showAll(servicingMap, countryName);
  }
}

function showAll(servicingMap, countryName) {
  $("[data-country]", "#servicing-table").show();
  var worldBounds = new google.maps.LatLngBounds(new google.maps.LatLng(-65, -160), new google.maps.LatLng(65, 160));
  servicingMap.fitBounds(worldBounds);
  servicingMap.setZoom(2);
}

function centerMapToCountry(countryName) {
  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    'address': countryName
  }, function (results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      servicingMap.setCenter(results[0].geometry.location);
      servicingMap.fitBounds(results[0].geometry.viewport);
    }
  });
}

function countrySelectDropdown(data, sort, countryName) {
  $("#servicing-list").html(function () {
    var content = "<select><option>All countries</option>";
    var countryList = [];
    $.each(dynamicSort(data, sort), function (index, location) {
      countryList.push(location.country);
    });
    countryList = _toConsumableArray(new Set(countryList));
    $.each(countryList, function (index, country) {
      if (country === countryName) {
        content += "<option data-country=\"".concat(country, "\" selected>").concat(country, "</option>");
      } else {
        content += "<option data-country=\"".concat(country, "\">").concat(country, "</option>");
      }
    });
    content += '</select>';
    return content;
  });
}

function fillServicingTable(data, sort, countryName) {
  $("#servicing-table").html(function () {
    var content = "";
    $.each(dynamicSort(data, sort), function (index, location) {
      content += "<tr data-country=\"".concat(location.country, "\">\n                    <td>").concat(location.dealer, "</td>\n                    <td>").concat(location.location, "</td>\n                    <td>").concat(location.country, "</td>\n                    <td><a class=\"servicing-marker-link\" data-markerid=\"").concat(location.id, "\" href=\"#servicing-map\">View on map</a></td>\n                </tr>");
    });
    return content;
  });
  $('.servicing-marker-link').on('click', function () {
    google.maps.event.trigger(markers[$(this).data('markerid')], 'click');
  });
}

function dynamicSort(data, property) {
  return data.sort(function (a, b) {
    return a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
  });
}

/***/ }),

/***/ "./src/js/modules/slides.js":
/*!**********************************!*\
  !*** ./src/js/modules/slides.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  featureGallery: {
    gallery: $('.features-gallery__main'),
    init: function init() {
      if (this.gallery.length) {
        this.gallery.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        });
      }
    },
    goTo: function goTo(event, index) {
      $('.features-gallery__nav .active').removeClass('active');
      event.target.closest('.features-gallery__nav-item').classList.add('active');
      this.gallery.slick('slickGoTo', index);
    }
  },
  sliderGallery: {
    gallery: $('.gallery__main'),
    init: function init() {
      if (this.gallery.length) {
        this.gallery.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true
        });
      }
    }
  }
});

/***/ }),

/***/ "./src/js/modules/splititInit.js":
/*!***************************************!*\
  !*** ./src/js/modules/splititInit.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ splititInit)
/* harmony export */ });
function splititInit() {
  function splititPdpVariant() {
    var variantId = ShopifyAnalytics && ShopifyAnalytics.meta.selectedVariantId;
    var productVariants = getVariants();
    var productVariant;
    productVariants.forEach(function (element, index) {
      if (element.id === variant.id) {
        productVariant = productVariants[index];
      }
    });
    if (!productVariant) return;
    var variantPrice = productVariant.price;
    var priceMoney = variantPrice / 10; // Set the data attribute with new value

    $("#splitit-container").attr('data-splitit-amount', priceMoney);
    window.calculator.price = variantPrice; // Render placement with new information

    splitit && splitit.ui.refresh();
  }

  function getVariants() {
    return ShopifyAnalytics && ShopifyAnalytics.meta.product.variants;
  }

  var productUrl = document.URL;
  document.addEventListener('change', function () {
    var currentUrl = document.URL;
    var url = new URL(currentUrl);
    var isVariantUrl = url.searchParams.get("variant");
    currentUrl = isVariantUrl ? currentUrl : isVariantUrl;

    if (currentUrl && productUrl != currentUrl) {
      productUrl = currentUrl;
      splititPdpVariant();
    }
  });
}

/***/ }),

/***/ "./src/css/app.scss":
/*!**************************!*\
  !*** ./src/css/app.scss ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					result = fn();
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/williams": 0,
/******/ 			"assets/williams": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkwilliamsformula1"] = self["webpackChunkwilliamsformula1"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/williams"], () => (__webpack_require__("./src/js/app.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/williams"], () => (__webpack_require__("./src/css/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;